import { render, staticRenderFns } from "./ChekUps.vue?vue&type=template&id=12723544"
import script from "./ChekUps.vue?vue&type=script&lang=js"
export * from "./ChekUps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports